<div class="wrap" 
[style.background]="stepsStylingMap.get(contractStep.target_type).stepColor +'!important'"
>
<h2>Смена названия этапа</h2>
<textarea class="wrap-text"
[style.background]="stepsStylingMap.get(contractStep.target_type).stepColor +'!important'"
[style.border-color]="stepsStylingMap.get(contractStep.target_type).stepActiveColor +'!important'"
        [(ngModel)]="contractStep.name"  rows="2"
    ></textarea>
</div>